import * as React from 'react'
import { Link as RouterLink, LinkProps } from 'react-router-dom'
import styled, { css, ThemeProps } from 'style/styled-components'
import Theme from 'style/theme'

const BaseStyle = css`
  text-decoration: none;
  color: ${(props: ThemeProps<Theme>): string => props.theme.font.color.highlight};
  font-weight: ${(props: ThemeProps<Theme>): string => props.theme.font.weight.normal};
  
  :hover {
    color: ${(props: ThemeProps<Theme>): string => props.theme.font.color.highlightDark};
  }
`

const StyledLink = styled(RouterLink)`
  ${BaseStyle}
`

const StyledAnchor = styled.a`
  ${BaseStyle}
`

const IsExternalLink = (href: string): boolean => {
  const externalLinkIdentifier = 'http'
  return href.toLowerCase().substr(0, externalLinkIdentifier.length) === externalLinkIdentifier
}

const Link = (props: LinkProps): JSX.Element => (
  IsExternalLink(props.to.toString())
    ? <StyledAnchor href={props.to.toString()} {...props} />
    : <StyledLink {...props} />
)

export default Link



// WEBPACK FOOTER //
// ./src/components/_atoms/link.tsx